import React from "react";
import { Modal } from "react-onsenui";
import QueryEditor from "./QueryEditor";

export default class QueryEditorModal extends React.Component {
  render() {
    const {
      queries,
      query,
      currentSubstanceIds,
      onQueryChange,
      availableReagentIds,
      onClose
    } = this.props;

    return (
      <QueryEditor
        queries={queries}
        query={query}
        currentSubstanceIds={currentSubstanceIds}
        onClose={onClose.bind(this)}
        onQueryChange={onQueryChange.bind(this)}
        availableReagentIds={availableReagentIds}
      />
    );
  }
}
